import * as React from 'react';
import { SVGProps } from 'react';

const IconMapStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 8.535a1 1 0 0 1 .445-.832l5.117-3.411a1 1 0 0 1 .926-.097L19 8l5.223-3.482a.5.5 0 0 1 .777.416v15.448a1 1 0 0 1-.553.894L19.402 23.8a1 1 0 0 1-.819.034L9 20l-5.223 3.482A.5.5 0 0 1 3 23.066V8.536ZM6 9v10l1.5-1V8L6 9Zm14.5 1L22 9v10.5l-1.5.75V10Zm-10-2.4v10l7 2.8v-10l-7-2.8Z"
    />
  </svg>
);
export default IconMapStrokedSizeL;
